import React from 'react';
import { Row, Col } from 'shards-react';

const Slides = props => {
  const { slides } = props;
  return (
    <Row>
      <Col sm="12" md={{ size: 10, offset: 1 }}>
        <div className="list">
          <h4>Course Lectures</h4>
          <table>
            <thead>
              <tr>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {slides.map(slide => (
                <tr>
                  <td><a href={slide.link}>{slide.name}</a></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Col>
    </Row>
  );
};

export default Slides;
